export default "__VITE_ASSET__9lO6u8GG__"